var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCircleNotch180(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.165,
    height: 81.989,
    viewBox: "0 0 83.165 81.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-circle-notch",
    "data-name": "Icon awesome-circle-notch",
    d: "M47.51,5.087V7.88a4.026,4.026,0,0,0,2.965,3.868,30.851,30.851,0,1,1-16.662,0A4.026,4.026,0,0,0,36.779,7.88V5.089a4.027,4.027,0,0,0-5.038-3.9,41.582,41.582,0,1,0,20.764-.011A4.017,4.017,0,0,0,47.51,5.087Z",
    transform: "translate(83.727 83.045) rotate(180)",
    fill: "#faa378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNotch180);
export default __webpack_public_path__ + "static/media/icon-circle-notch180.b24fea908cf17d7a01f95ff4c5203c58.svg";
export { ForwardRef as ReactComponent };